export default "__VITE_PUBLIC_ASSET__b28d40f6__"